module.exports = __webpack_public_path__ + "static/img/成功案例1.8e3dd7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/成功案例1.png
// module id = 5I3v
// module chunks = 1